import React from "react";
import Devservices from "../components/ServiceComponents/Devservices";
import CardSlider from "../components/ServiceComponents/CardSlider";
import Uidesign from "../components/ServiceComponents/Uidesign";
import Contact from "../components/ServiceComponents/Contact";

export const Service = () => {
  return (
    <div>
      <Devservices />
      <CardSlider />
      <Uidesign/>
      <Contact/>
    </div>
  );
};
